<template>
    <div
        class="review-order container"
        :class="{
            'bg-white':isHasBookingItems,
            'p-4' : isStandalone,
            'p-3 backend' : !isStandalone
        }"
    >
        <googleRecaptcha v-if="isStandalone" ref="googleRecaptcha" @scriptLoaded="googleScriptLoaded" />
        <div v-if="isMissingRequest && isStandalone" class="container bg-white p-5 text-center">
            <div class="h4 mb-0 text-black">Review {{ labelCaption }}</div>
            <div class="text-danger lh-1-2">
                We regret to inform you that product orders cannot be accepted at the moment.
            </div>
            <div>
                <img :src="'/assets/dta/img/booking-order.jpg'" alt="booking order" class="img-fluid" style="width:400px">
            </div>
            <div>
                <a href="/tours" class="btn btn_1">View Other Products</a>
            </div>
        </div>
        <div v-else-if="errorMessage && !isStandalone" class="container bg-white text-center">
            <div class="text-danger lh-1-2">{{ errorMessage }}</div>
            <div>
                <img :src="'/assets/dta/img/booking-order.jpg'" alt="booking order" class="img-fluid" style="width:400px">
            </div>
        </div>
        <div v-else-if="isHasBookingItems" class="row gx-3">
            <div class="col-lg-12 col-xl-8">
                <div v-if="isStandalone" class="title-label mb-3">
                    <div class="h4 mb-0 text-black">{{ labelCaption }}</div>
                    <div>Review your booking.</div>
                </div>

                <div v-if="!isStandalone && (bookingItems.invoice_note || bookingItems.important_note || bookingItems.item_note)" class="review-details mb-3 border border-danger">
                    <div class="section-header">
                        <div class="section-title text-white fw-semibold">{{ bookingItems.important_note ? '[!] IMPORTANT note' : '[!] CANCELLATION INFORMATION' }}</div>
                    </div>
                    <div class="detail-row flex-column align-items-start">
                        <template v-if="bookingItems.important_note">
                            <div class="detail-value text-danger mb-2" v-html="bookingItems.important_note"></div>
                        </template>
                        <div v-if="bookingItems.invoice_note || bookingItems.item_note" class="detail-value text-danger" style="white-space: pre-wrap;" v-html="bookingItems.invoice_note || bookingItems.item_note"></div>
                    </div>
                </div>

                <div class="review-details mb-3">
                    <div class="section-header">
                        <div class="section-title">Guest Information</div>
                    </div>

                    <template  v-if="isBookingFor">
                        <div class="detail-row">
                            <div class="detail-label">Full Name</div>
                            <div class="detail-value">{{ bookingItems.op_name }}</div>
                        </div>
                        <div class="detail-row">
                            <div class="detail-label">Nationality</div>
                            <div class="detail-value">{{ bookingItems.op_nationality }}</div>
                        </div>
                        <div class="detail-row">
                            <div class="detail-label">E-Mail Address</div>
                            <div class="detail-value">{{ bookingItems.op_email }}</div>
                        </div>
                        <div class="detail-row">
                            <div class="detail-label">Phone or WhatsApp</div>
                            <div class="detail-value">{{ bookingItems.op_phoneNumber }}</div>
                        </div>
                        <div class="section-header">
                            <div class="section-title">Booker Information</div>
                        </div>
                    </template>

                    <div class="detail-row">
                        <div class="detail-label">Full Name</div>
                        <div class="detail-value">{{ bookingItems.name }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">Nationality</div>
                        <div class="detail-value">{{ bookingItems.nationality }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">E-Mail Address</div>
                        <div class="detail-value">{{ bookingItems.email }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">Phone or WhatsApp</div>
                        <div class="detail-value">{{ bookingItems.phoneNumber }}</div>
                    </div>
                </div>

                <div v-if="billingAddress" class="review-details mb-3">
                    <div class="section-header">
                        <div class="section-title">Billing Address</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-value">{{ billingAddress }}</div>
                    </div>
                </div>

                <div v-if="bookingItems.departure_detail" class="review-details mb-3">
                    <div class="section-header">
                        <div class="section-title">Arrival or Departure Details</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-value" style="white-space: pre-wrap;" v-html="bookingItems.departure_detail"></div>
                    </div>
                </div>

                <div class="item-details mb-3">
                    <div class="section-header rounded-top">
                        <div class="section-title">Booking Items</div>
                    </div>
                    <div class="order-items rounded-0 rounded-bottom">
                        <div class="item-header">
                            <div class="item-description">Description</div>
                            <div class="item-price">Price</div>
                            <div class="item-qty">Qty</div>
                            <div class="item-total">Total</div>
                        </div>
                        <template v-if="isHasRoom">
                            <div class="item-row isHasRoom">
                                <div class="item-description">
                                    <div class="service-name">{{ bookingItems.itemGroup.label }}</div>
                                    <div class="rooming-note lh-1">
                                        <small v-if="bookingItems.itemGroup.rooming_info.note" ><span class="ti ti-vocabulary"></span> {{ bookingItems.itemGroup.rooming_info.note }}</small>
                                        <small v-if="bookingItems.itemGroup.rooming_info.capacity"><span class="ti ti-users"></span> {{ bookingItems.itemGroup.rooming_info.capacity }}</small>
                                        <small v-if="bookingItems.itemGroup.rooming_info.room"><span class="ti ti-door"></span> {{ bookingItems.itemGroup.rooming_info.room }}</small>
                                        <small v-if="bookingItems.itemGroup.rooming_info.bed"><span class="ti ti-bed-flat"></span> {{ bookingItems.itemGroup.rooming_info.bed }}</small>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="isGroup">
                            <div class="item-row isGroup">
                                <div class="item-description">
                                    <div class="service-name">{{ bookingItems.itemGroup.label }}</div>
                                </div>
                            </div>
                        </template>
                        <div v-if="hasItems"
                             class="item-row"
                             v-for="item in bookingItems.items"
                        >
                            <div class="item-description">
                                <div class="service-name">{{ item.label }}</div>
                                <template v-if="isVehicle">
                                    <div v-if="item.note" class="service-details">{{ item.note }}</div>
                                    <div v-if="item.service_info.duration || item.service_info.hour_start || item.service_info.hour_last" class="service_info">
                                        <span v-if="item.service_info.duration" class="duration">{{ `${item.service_info.duration} ${item.service_info.duration_type + ((item.service_info.duration_type!=='v.v (oneway)' && parseInt(item.service_info.duration || '')>1)? 's' : '')}` }} (Duration)</span>
                                        <span v-if="(item.service_info.hour_start || item.service_info.hour_last)" class="clock">{{ (item.service_info.hour_start || '') + ((item.service_info.hour_start || '') && (item.service_info.hour_last || '')?'-':'') + (item.service_info.hour_last || '') }}</span>
                                    </div>
                                </template>
                            </div>
                            <div class="item-price">{{ formatNumber(item.price) }}</div>
                            <div class="item-qty">{{ item.total }}</div>
                            <div class="item-total">{{ formatNumber(item.total_price) }}</div>
                        </div>
                        <div v-if="hasPickup" class="item-row">
                            <div class="item-description">
                                <div><small>Pickup Location</small></div>
                                <div class="service-name" v-if="(isReturnDifferentDay || isDepartureTicket || isReturnDifferentDPTP) && isHasReturnPickup">
                                    <i>{{  (isReturnDifferentDay || isReturnDifferentDPTP ? `(${bookingItems.departureDate}) ` : '') + bookingItems.pickup.label }}</i>
                                    <span class="px-1 text-primary"><i>to</i></span>
                                    <i>{{ bookingItems.returnPickup.name }}</i>
                                </div>
                                <div v-else class="service-name">{{ bookingItems.pickup.label }}</div>
                                <div v-if="locationServiceInfo(bookingItems.pickup.service_info)" class="service_info" v-html="locationServiceInfo(bookingItems.pickup.service_info)" />
                            </div>
                            <div class="item-price">-</div>
                            <div class="item-qty">-</div>
                            <div class="item-total">{{ formatNumber(bookingItems.pickup.total_price) }}</div>
                        </div>
                        <div v-if="hasDropOff" class="item-row">
                            <div class="item-description">
                                <div><small>Drop Off Location</small></div>
                                <div class="service-name" v-if="(isReturnDifferentDay || isReturnTicket || isReturnDifferentDPTP) && isHasReturnPickup">
                                    <i>{{ (isReturnDifferentDay || isReturnDifferentDPTP ? `(${bookingItems.returnDate}) ` : '') + bookingItems.returnPickup.name }}</i>
                                    <span class="px-1 text-primary"><i>to</i></span>
                                    <i>{{ bookingItems.dropOff.label }}</i>
                                </div>
                                <div v-else class="service-name">{{ bookingItems.dropOff.label }}</div>
                                <div v-if="locationServiceInfo(bookingItems.dropOff.service_info)" class="service_info" v-html="locationServiceInfo(bookingItems.dropOff.service_info)" />
                            </div>
                            <div class="item-price">-</div>
                            <div class="item-qty">-</div>
                            <div class="item-total">{{ formatNumber(bookingItems.dropOff.total_price) }}</div>
                        </div>
                        <template v-if="hasAddons">
                            <div class="item-header">
                                <div class="item-description">Add Ons</div>
                            </div>
                            <template v-for="item in bookingItems.addons">
                                <template v-if="item.hasOwnProperty('groupItems')">
                                    <div v-for="subItem in item.groupItems" class="item-row"
                                    >
                                        <div class="item-description">
                                            <div class="service-name">{{ item.label }} - {{ subItem.label }}</div>
                                            <div v-if="item.departure_date || subItem.departure_date" class="service-details">
                                                <span>Departure Date: {{ formatAddonDate(item.departure_date || subItem.departure_date) }}</span>
                                            </div>
                                        </div>
                                        <div class="item-price">{{ formatNumber(subItem.price) }}</div>
                                        <div class="item-qty">{{ subItem.total }}</div>
                                        <div class="item-total">{{ formatNumber(subItem.total_price) }}</div>
                                    </div>
                                </template>
                                <div v-else class="item-row">
                                    <div class="item-description">
                                        <div class="service-name">{{ item.label }}</div>
                                        <div v-if="item.departure_date" class="service-details">
                                            <span>Departure Date: {{ formatAddonDate(item.departure_date) }}</span>
                                        </div>
                                    </div>
                                    <div class="item-price">{{ formatNumber(item.price) }}</div>
                                    <div class="item-qty">{{ item.total }}</div>
                                    <div class="item-total">{{ formatNumber(item.total_price) }}</div>
                                </div>
                            </template>
                        </template>
                        <div class="item-summary border-top-0">
                            <div v-if="bookingItems.discount" class="summary-row text-danger">
                                <div class="summary-label">Promo Code ({{ promocode }})</div>
                                <div class="summary-value">-{{ formatNumber(bookingItems.discount) }}</div>
                            </div>
                            <div class="summary-row total">
                                <div class="summary-label">Total Amount</div>
                                <div class="summary-value">{{ formatNumber(bookingItems.totalPrice) }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="hasManifests" class="travel-manifest mb-3 ">
                    <div class="section-header rounded-top">
                        <div class="section-title">Travel Manifest</div>
                    </div>
                    <div class="manifest-table rounded-0 rounded-bottom">
                        <div class="manifest-header">
                            <div class="manifest-name">Full Name</div>
                            <div class="manifest-nationality">Nationality</div>
                            <div class="manifest-dob">Date of Birth</div>
                            <div class="manifest-phone">Phone/WhatsApp</div>
                            <div class="manifest-passport">Passport Number</div>
                        </div>
                        <template v-if="isHasRoom">
                            <template v-for="(room, index) in bookingItems.manifests">
                                <div class="manifest-rooming">
                                    <div class="manifest-room">
                                        Room #{{ index + 1 }}
                                    </div>
                                </div>
                                <div
                                    v-for="item in room"
                                    class="manifest-row"
                                    :class="item.label_guest_type.toLowerCase()"
                                >
                                    <div class="manifest-name">
                                        <div v-if="item.title" class="traveler-name">{{ `${item.title}. ${item.name}` }}</div>
                                        <div v-else class="traveler-name">{{ item.name }}</div>
                                        <div class="traveler-type">{{ item.label_guest_type }} ({{ item.label_age }})</div>
                                    </div>
                                    <div class="manifest-nationality">{{ item.nationality }}</div>
                                    <div class="manifest-dob">{{ item.label_birthdate }}</div>
                                    <div class="manifest-phone">{{ item.phone }}</div>
                                    <div class="manifest-passport">{{ item.passport }}</div>
                                </div>
                            </template>
                        </template>
                        <div
                            v-else
                            v-for="item in bookingItems.manifests"
                            class="manifest-row"
                            :class="item.label_guest_type.toLowerCase()"
                        >
                            <div class="manifest-name">
                                <div v-if="item.title" class="traveler-name">{{ `${item.title}. ${item.name}` }}</div>
                                <div v-else class="traveler-name">{{ item.name }}</div>
                                <div class="traveler-type">{{ item.label_guest_type }} ({{ item.label_age }})</div>
                            </div>
                            <div class="manifest-nationality">{{ item.nationality }}</div>
                            <div class="manifest-dob">{{ item.label_birthdate }}</div>
                            <div class="manifest-phone">{{ item.phone }}</div>
                            <div class="manifest-passport">{{ item.passport }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <aside class="col-lg-12 col-xl-4" id="sidebar">
                <div class="card shadow-sm border rounded mb-3 booking-detail">
                    <div class="card-header">
                        <div v-if="bookingItems.bookingNumberId" class="card-title mb-0 h6 text-black d-flex justify-content-between align-items-center">
                            <span>Booking Details</span>
                            <span class="badge bg-primary fw-bolder">#{{ bookingItems.bookingNumberId }}</span>
                        </div>
                        <div v-else class="card-title mb-0 h6 text-black">
                            Booking Details
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="mb-2">
                            <div class="product fw-semibold">{{ bookingItems.productName }}</div>
                            <div v-for="destination in bookingItems.destinations" class="destination lh-1"><small>{{ destination }}</small></div>
                        </div>
                        <div class="mb-2">
                            <div class="text-muted"><small>Currency</small></div>
                            <div>{{ bookingItems.currencyCode + ' - ' + bookingItems.currencyName }}</div>
                        </div>
                        <div class="mb-2">
                            <div class="text-muted"><small>{{ isReturnTicket ? 'Travel return date' : 'Travel departure date' }}</small></div>
                            <div>{{ bookingItems.departureDate }}</div>
                        </div>
                        <div v-if="(isReturnDifferentDay || isReturnDifferentDPTP) && bookingItems.returnDate" class="mb-2">
                            <div class="text-muted"><small>Travel return date</small></div>
                            <div>{{ bookingItems.returnDate }}</div>
                        </div>
                        <div v-if="isHasComplimentary" class="mb-2">
                            <div class="text-muted"><small>Local Agent Support</small></div>
                            <div class="fw-semibold">{{ bookingItems.ccs_support_option.name }}</div>
                            <div class="lh-1"><small>{{ travelAgentAddress(bookingItems.ccs_support_option) }}</small></div>
                        </div>
                        <hr >
                        <div>
                            <div class="text-muted"><small>Booking Items</small></div>
                            <template v-if="isHasRoom">
                                <div class="mb-3">
                                    <div class="lh-1">{{ bookingItems.itemGroup.label + (totalRooms>1 ? ` (${totalRooms} rooms)` : '') }}</div>
                                    <div class="rooming-note lh-1">
                                        <small v-if="bookingItems.itemGroup.rooming_info.note" ><span class="ti ti-vocabulary"></span> {{ bookingItems.itemGroup.rooming_info.note }}</small>
                                        <small v-if="bookingItems.itemGroup.rooming_info.capacity"><span class="ti ti-users"></span> {{ bookingItems.itemGroup.rooming_info.capacity }}</small>
                                        <small v-if="bookingItems.itemGroup.rooming_info.room"><span class="ti ti-door"></span> {{ bookingItems.itemGroup.rooming_info.room }}</small>
                                        <small v-if="bookingItems.itemGroup.rooming_info.bed"><span class="ti ti-bed-flat"></span> {{ bookingItems.itemGroup.rooming_info.bed }}</small>
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="isGroup">
                                <div class="mb-3">
                                    <div class="lh-1">{{ bookingItems.itemGroup.label }}</div>
                                    <div class="text-muted lh-1"><small>{{ bookingItems.itemGroup.note }}</small></div>
                                </div>
                            </template>
                            <div
                                v-if="hasItems"
                                v-for="item in bookingItems.items"
                                class="d-flex justify-content-between align-items-center"
                            >
                                <div class="pe-2">
                                    <div>{{ item.total + ' ' + item.label + (isVehicle?'':(item.total>=2?'s':'')) }}</div>
                                    <div v-if="isVehicle && item.note" class="text-muted lh-1"><small>{{ item.note }}</small></div>
                                </div>
                                <div>{{ formatNumber(item.total_price) }}</div>
                            </div>
                            <hr v-if="hasPickup || hasDropOff" >
                            <div
                                v-if="hasPickup"
                                class="d-flex justify-content-between align-items-center mt-1"
                            >
                                <div class="lh-1 pe-2">
                                    <div class="text-muted"><small>Pickup Location</small></div>
                                    <div v-if="(isReturnDifferentDay || isDepartureTicket || isReturnDifferentDPTP) && isHasReturnPickup">
                                        <i>{{ bookingItems.pickup.label }}</i>
                                        <span class="px-1 text-primary"><i>to</i></span>
                                        <i>{{ bookingItems.returnPickup.name }}</i>
                                    </div>
                                    <div v-else>{{ bookingItems.pickup.label }}</div>
                                </div>
                                <div>{{ formatNumber(bookingItems.pickup.total_price) }}</div>
                            </div>
                            <div
                                v-if="hasDropOff"
                                class="d-flex justify-content-between align-items-center mt-1"
                            >
                                <div class="lh-1 pe-2">
                                    <div class="text-muted"><small>Drop Off Location</small></div>
                                    <div v-if="(isReturnDifferentDay || isReturnTicket || isReturnDifferentDPTP) && isHasReturnPickup">
                                        <i>{{ bookingItems.returnPickup.name }}</i>
                                        <span class="px-1 text-primary"><i>to</i></span>
                                        <i>{{ bookingItems.dropOff.label }}</i>
                                    </div>
                                    <div v-else>{{ bookingItems.dropOff.label }}</div>
                                </div>
                                <div>{{ formatNumber(bookingItems.dropOff.total_price) }}</div>
                            </div>
                            <template v-if="hasAddons">
                                <hr>
                                <div class="mb-2"><i>Add Ons</i></div>
                                <template v-for="item in bookingItems.addons">
                                    <template v-if="item.hasOwnProperty('groupItems')">
                                        <div> {{ item.label }}</div>
                                        <div v-if="item.departure_date" class="text-muted lh-1 mb-1">
                                            <small>Departure: {{ formatAddonDate(item.departure_date) }}</small>
                                        </div>
                                        <div
                                            v-for="subItem in item.groupItems"
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <div class="px-2 text-muted"><span class="ti ti-point"></span>{{ subItem.total + ' ' + subItem.label + (subItem.total>=2?'s':'') }}</div>
                                            <div>{{ formatNumber(subItem.total_price) }}</div>
                                        </div>
                                    </template>
                                    <div
                                        v-else
                                        class="d-flex justify-content-between align-items-center"
                                    >
                                        <div class="pe-2">
                                            <div>{{ item.total + ' ' + item.label + (item.total>=2?'s':'') }}</div>
                                            <div v-if="item.departure_date" class="text-muted lh-1">
                                                <small>Departure: {{ formatAddonDate(item.departure_date) }}</small>
                                            </div>
                                        </div>
                                        <div>{{ formatNumber(item.total_price) }}</div>
                                    </div>
                                </template>
                            </template>
                            <hr>
                            <div v-if="bookingItems.discount" class="d-flex justify-content-between align-items-center text-danger">
                                <div>Promo Code ({{ promocode }})</div>
                                <div>-{{ formatNumber(bookingItems.discount) }}</div>
                            </div>
                            <hr v-if="bookingItems.discount">
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <div>Total Amount</div>
                                <div>{{ formatNumber(bookingItems.totalPrice) }}</div>
                            </div>
                            <div v-if="bookingItems.invoice_number_id" class="d-flex justify-content-between align-items-center mb-1">
                                <div>Invoice Number</div>
                                <div>#{{ bookingItems.invoice_number_id }}</div>
                            </div>
                            <div v-if="bookingItems.invoice_status" class="d-flex justify-content-between align-items-center mb-1">
                                <div>Invoice Status</div>
                                <span class="badge" :class="{
                                    'bg-label-danger': ['Underpaid', 'Overpaid', 'Cancelled'].includes(bookingItems.invoice_status),
                                    'bg-label-success': bookingItems.invoice_status === 'Paid',
                                    'bg-label-warning': bookingItems.invoice_status === 'Pending'
                                }">{{ bookingItems.invoice_status }}</span>
                            </div>
                            <div v-if="bookingItems.invoice_outstanding !== undefined" class="d-flex justify-content-between align-items-center mb-1" :style="{ color: bookingItems.invoice_status === 'Overpaid' ? '#006400' : '#dc3545' }">
                                <div>Invoice Outstanding</div>
                                <div class="fw-bold">
                                    {{ (bookingItems.invoice_status === 'Overpaid' ? '-' : '') + formatNumber(Math.abs(bookingItems.invoice_outstanding), (Math.abs(bookingItems.invoice_outstanding) > 0 ? (bookingItems.invoice_currency_symbol || '$') : '')) }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!bookingItems.bookingId" class="card-footer">
                        <div v-if="isHasBookingItems" class="mb-3 mt-2">
                            <div class="">
                                <label class="mb-1"><small>Promo Code</small></label>
                                <div class="d-flex justify-content-between align-items-center gap-2">
                                    <text-input
                                        placeholder="Enter promo code"
                                        v-model="promocode"
                                        :white-space="false"
                                        :upper-case="true"
                                        :disabled="isPromoApplied"
                                    />
                                    <button
                                        v-if="!isPromoApplied"
                                        class="btn btn-secondary btn_1 fw-normal"
                                        type="button"
                                        @click="applyPromoCode"
                                        style="height: 42px; padding-top: 10px; padding-bottom: 10px;"
                                    >
                                        Apply
                                    </button>
                                    <button
                                        v-else
                                        class="btn btn-danger btn_1 fw-normal"
                                        type="button"
                                        @click="removePromoCode"
                                        style="height: 42px; padding-top: 10px; padding-bottom: 10px;"
                                    >
                                        Remove
                                    </button>
                                </div>
                                <div v-if="promoErrorMessage" class="text-danger">
                                    <small>{{ promoErrorMessage }}</small>
                                </div>
                            </div>
                            <template v-if="(bookingItems || {}).cs">
                                <div class="pt-3">
                                    <div class="alert alert-info mb-0">
                                        <strong>Choose Your Personal Travel Concierge</strong><br>
                                        Select our local agent representative near you to act as your dedicated customer service point. If necessary, you can contact them in future as they are available to assist with your booking, provide local advice, and help with extras like air tickets or visa applications—at no extra cost to you.
                                    </div>
                                </div>
                                <div class="pt-2">
                                    <div class="d-flex align-items-center justify-content-between mt-2">
                                        <div class="d-flex align-items-center">
                                            <a href="javascript:void(0)" class="text-primary me-1" data-bs-toggle="tooltip" data-bs-container="body" data-bs-html="true" data-bs-placement="top" data-bs-custom-class="tooltip-wide" title="<div class='text-start lh-1-2'><strong class='fw-bold text-decoration-underline'>Free Service</strong><br>Having a local agent representative is a bonus for you. That means you have a real person to call in your timezone who can handle complex add-ons like flights and visas that you can't always do online.</div>" @click="showWhy">
                                                <i class="ti ti-info-circle ti-xs"></i>
                                            </a>
                                            <label class="form-label mb-0 label-travel-agent">Local Agent Support <span class="text-danger">*</span></label>
                                        </div>
                                        <span class="badge bg-label-info">Complimentary Service</span>
                                    </div>
                                </div>
                                <div class="pb-3">
                                    <selectTravelAgent
                                        ref="ccsSelectAgent"
                                        v-model="ccs_support"
                                        :class="{'is-invalid': ccs_support_error}"
                                        :class-input="ccs_support_error ? 'is-invalid' : ''"
                                        name="ccs_support"
                                        placeholder="Local agent support..."
                                        :dd-auto-refresh="true"
                                        :required="true"
                                        :endpoint="(loggedIn || !isStandalone) ? $gpApp.baseSpaAppUrl('/travel-agent') : null"
                                        :open-endpoint="(!loggedIn && isStandalone) ? '/travel-agent' : null"
                                        :before-run-endpoint="runEndpointCcsSelectAgent"
                                        :options="(ccsSupportOptions||[])"
                                        :disabled="ccsStrict"
                                    />
                                </div>
                            </template>
                        </div>
                        <a
                            v-if="isStandalone"
                            class="btn btn-primary w-100 btn-continue btn_1 full-width"
                            :href="bookingItems.updateLink"
                        >
                            Change Booking
                        </a>
                        <a
                            v-else
                            class="btn btn-primary w-100 btn-continue btn_1 full-width"
                            href="javascript:void(0);"
                            @click="$emit('changeBooking')"
                        >
                            Change Booking
                        </a>
                        <button
                            v-if="!hideShoppingCart"
                            type="button"
                            class="btn btn-primary w-100 btn-continue btn_1 full-width"
                            @click="addShoppingCart($event)"
                        >
                            {{ bookingItems.shoppingCartLink ? 'Save to Shopping Cart' : 'Add Shopping Cart' }}
                        </button>
                        <button
                            v-if="bookingItems.available"
                            type="button"
                            class="btn btn-primary w-100 btn-checkout btn_1 full-width purchase"
                            @click="proceedToCheckout"
                        >
                            Proceed to Checkout
                        </button>
                    </div>
                </div>
                <template v-if="isStaffEditBO">
                    <div class="card shadow-sm border rounded mb-3 booking-detail">
                        <div class="card-header">
                            <div class="card-title mb-0 h6 text-black">
                                NOTIFICATION
                            </div>
                        </div>
                        <div class="card-body">
                            <form class="needs-validation" novalidate>
                                <div class="row g-3">
                                    <div class="col-md-12">
                                        <text-input
                                            label="Subject"
                                            placeholder="Enter subject"
                                            v-model="notification.subject"
                                            :required="true"
                                        />
                                    </div>
                                    <div class="col-md-12">
                                        <text-area-input
                                            label="Message"
                                            placeholder="Enter message"
                                            v-model="notification.message"
                                            :required="true"
                                            :rows="3"
                                        />
                                    </div>
                                    <div class="col-md-12">
                                        <checkbox-input
                                            v-model="notification.attachments"
                                            :options="[
                                                { label: 'Attach PDF Booking Order', value: 'booking', class: 'form-check-primary' },
                                                { label: 'Attach PDF Invoice', value: 'invoice', class: 'form-check-primary' }
                                            ]"
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="card-footer">
                            <button
                                type="button"
                                class="btn btn-primary w-100"
                                @click="sendNotification"
                            >
                                Send Message
                            </button>
                        </div>
                    </div>
                </template>
            </aside>
        </div>
    </div>
</template>

<script>

import './css/form-order.scss';
import moment from "moment";
import googleRecaptcha from "../../../../components/form/googleRecaptcha.vue";
import ApiService from "../../../../services/api.js";
import {objectHelper} from "../../../../utils/helpers/objectHelper.js";
import {errorHelper} from "../../../../utils/helpers/errorHelper.js";
import AjxService from "../../../../services/ajax.js";
import {formatHelper} from "../../../../utils/helpers/formatHelper.js";
import {gid, setgeo} from "../../../../utils/webRequest.js";
import {utilHelper} from "../../../../utils/helpers/utilHelper.js";
import {sweetAlertHelper} from "../../../../utils/helpers/sweetAlertHelper.js";
import {elementHelper} from "../../../../utils/helpers/elementHelper.js";
import {toolbox} from "../../../../components/toolbox/toolbox.js";
import SelectTravelAgent from "../../../../components/form/selectTravelAgent.vue";
import {formHelper} from "../../../../utils/helpers/formHelper.js";

export default {
    name: "reviewOrder",
    components: {
        SelectTravelAgent,
        googleRecaptcha,
        textInput : toolbox.textInput,
        selectInput : toolbox.selectInput,
        textAreaInput: toolbox.textAreaInput,
        checkboxInput: toolbox.checkboxInput
    },
    emits:[
        'changeBooking',
        'goShoppingCart',
        'goInvoice'
    ],
    props: {
        isStandalone: {
            type: Boolean,
            default: false
        },
        labelCaption: {
            type: String,
            default: 'Booking'
        },
        confirmId: {
            type: [null, String],
            default: null
        }
    },
    data() {
        return {
            isMounted: false,
            isMissingRequest: false,
            errorMessage: null,
            promoErrorMessage: null,
            isGoogleScriptLoaded: false,
            promocode: null,
            notification: {
                subject: null,
                message: null,
                attachments: []
            },
            bookingItems: {},
            ccs_support: null,
            ccsSupportOptions: [],
            ccs_support_error: false
        }
    },
    watch: {
        ccs_support(val) {
            if (val) {
                this.ccs_support_error = false;
            }
        },
        promocode(val) {
            if (val && val.length >= 5) {
                this.promoErrorMessage = null;
            }
        }
    },
    computed: {
        loggedIn() {
            return this.$store.getters["auth/loggedIn"];
        },
        isVehicle() {
            if(this.bookingItems.hasOwnProperty('isVehicle')) {
                return this.bookingItems.isVehicle;
            }
            return false;
        },
        isGroup() {
            if(this.bookingItems.hasOwnProperty('isGroup')) {
                return this.bookingItems.isGroup;
            }
            return false;
        },
        isHasRoom() {
            if(this.bookingItems.hasOwnProperty('isHasRoom')) {
                return this.bookingItems.isHasRoom;
            }
            return false;
        },
        hasPickup() {
            if(this.bookingItems.hasOwnProperty('pickup')) {
                return !objectHelper.isEmptyObject(this.bookingItems.pickup);
            }
            return false;
        },
        hasDropOff() {
            if(this.bookingItems.hasOwnProperty('dropOff')) {
                return !objectHelper.isEmptyObject(this.bookingItems.dropOff);
            }
            return false;
        },
        hasAddons() {
            if(this.bookingItems.hasOwnProperty('addons')) {
                return Array.isArray(this.bookingItems.addons) && this.bookingItems.addons.length > 0;
            }
            return false;
        },
        hasItems() {
            if(this.bookingItems.hasOwnProperty('items')) {
                return Array.isArray(this.bookingItems.items) && this.bookingItems.items.length > 0;
            }
            return false;
        },
        hasManifests() {
            if(this.bookingItems.hasOwnProperty('manifests')) {
                return Array.isArray(this.bookingItems.manifests) && this.bookingItems.manifests.length > 0;
            }
            return false;
        },
        totalRooms() {
            if(this.hasManifests) {
                return this.bookingItems.manifests.length;
            }
            return 0;
        },
        isBookingFor() {
            if(this.bookingItems.hasOwnProperty('booking_for')) {
                return formatHelper.parseBoolean(this.bookingItems.booking_for);
            }
            return false;
        },
        isHasComplimentary() {
            return !objectHelper.isEmptyObject(this.bookingItems.ccs_support_option);
        },
        isHasBookingItems() {
            return !objectHelper.isEmptyObject(this.bookingItems);
        },
        billingAddress() {
            let strAddress = this.bookingItems.billing_address || '';
            if(this.bookingItems.billing_city_name) {
                strAddress += `, ${this.bookingItems.billing_city_name}`;
            }
            if(this.bookingItems.billing_state_name) {
                strAddress += ` ${this.bookingItems.billing_state_name}`;
            }
            if(this.bookingItems.billing_country_name) {
                strAddress += ` ${this.bookingItems.billing_country_name}`;
            }
            if(this.bookingItems.billing_zipcode) {
                strAddress += ` ${this.bookingItems.billing_zipcode}`;
            }
            return strAddress;
        },
        isReturnDifferentDay() {
            return this.bookingItems.ticketType === 'Return on a Different Day';
        },
        isReturnDifferentDPTP() {
            return this.bookingItems.ticketType === 'Return on a Different DPTP';
        },
        isDepartureTicket() {
            return this.bookingItems.ticketType === 'One Way Departure';
        },
        isReturnTicket() {
            return this.bookingItems.ticketType === 'One Way Return';
        },
        isPointToPointTicket() {
            return this.bookingItems.ticketType === 'Point To Point';
        },
        isHasReturnPickup() {
            return !objectHelper.isEmptyObject(this.bookingItems.returnPickup);
        },
        hideShoppingCart() {
            return !!this.bookingItems.switchOrderId;
        },
        isPromoApplied() {
            return this.bookingItems.promocode && this.bookingItems.promocode !== 'invalid' && this.bookingItems.promocode === this.promocode;
        },
        ccsStrict() {
            return !!(this.bookingItems.hasOwnProperty('ccs_strict') && this.bookingItems.ccs_strict);
        },
        isStaffEditBO() {
            return this.bookingItems && this.bookingItems.staff_editbo;
        }
    },
    mounted() {
        this.isMounted = true;
        this.$nextTick(() => {
            this.setActivated();
            this.initTooltips();
            this.isMounted = false;
        });
    },
    unmounted() {
        this.setDeactivated();
    },
    activated() {
        if(!this.isMounted) {
            this.setActivated();
        }
    },
    deactivated() {
        this.setDeactivated();
    },
    methods: {
        showWhy() {
            sweetAlertHelper.alert(
                'Free Service',
                "<div class='lh-1-2'>Having a local agent representative is a bonus for you. That means you have a real person to call in your timezone who can handle complex add-ons like flights and visas that you can't always do online.</div>",
                'info'
            );
        },
        initTooltips() {
            this.$nextTick(() => {
                if (window.bootstrap && window.bootstrap.Tooltip) {
                    const tooltipTriggerList = [].slice.call(this.$el.querySelectorAll('[data-bs-toggle="tooltip"]'));
                    tooltipTriggerList.map(function (tooltipTriggerEl) {
                        const tooltip = window.bootstrap.Tooltip.getInstance(tooltipTriggerEl);
                        if (tooltip) {
                            tooltip.dispose();
                        }
                        new window.bootstrap.Tooltip(tooltipTriggerEl);
                    });
                }
            });
        },
        setActivated() {
            this.errorMessage = null;
            this.bookingItems = {};
            if (this.isGoogleScriptLoaded || !this.isStandalone) {
                this.getBookingItems();
            }
        },
        setDeactivated() {
            this.bookingItems = {};
            this.errorMessage = null;
        },
        async googleScriptLoaded() {
            if (this.isStandalone) {
                let geo = await gid();
                if (!geo) {
                    try {
                        const geoData = await setgeo();
                        geo = geoData.i;
                    } catch (error) {
                        this.isMissingRequest = true;
                    }
                }
                if(geo) {
                    const isGuest = window.localStorage.getItem("guest") === "isGuest";
                    if(!isGuest) {
                        await this.$store.dispatch("auth/getAuthUser").then(response => {
                        }).finally(() => {
                            this.getBookingItems();
                        });
                    } else {
                        await this.getBookingItems();
                    }
                } else {
                    this.isMissingRequest = true;
                }
            } else {
                await this.getBookingItems();
            }
        },
        formatNumber(number, symbol = null) {
            const price = (typeof (number || 0)) === 'number' ? (number || 0) : (!isNaN(parseFloat(number)) ? parseFloat(number) : 0);
            if(price) {
                const currencySymbol = symbol || this.bookingItems.currencySymbol;
                return currencySymbol + formatHelper.formatNumber(price, (currencySymbol.trim().toLowerCase()==='rp'?'id-ID':'en-US'));
            }
            return '-';
        },
        formatAddonDate(strDate) {
            if (!strDate) return '';
            try {
                const m = moment(strDate);
                return m.isValid() ? m.format('dddd, DD MMM YYYY') : strDate;
            } catch (e) {
                return strDate;
            }
        },
        async getBookingItems(isRemovePromoCode = false) {
            const loaderId = utilHelper.getUniqueId();
            const endpoint = `/booking/review/${this.confirmId}/get`;
            const payload = {};

            if(isRemovePromoCode) {
                payload.removelpc = true;
            } else if (this.promocode && this.promocode.length >= 5) {
                payload.promocode = this.promocode;
            }

            if(this.bookingItems.cs && this.ccs_support) {
                payload.ccs_support = this.ccs_support;
            }

            if (this.loggedIn) {
                if(!this.isStandalone) {
                    payload.staff = true;
                    elementHelper.loader.show(loaderId, this.$el.closest('.modal-body'), 36, 36, 'dots');
                }
                try {
                    const response = await ApiService.post(endpoint, payload);
                    if (!objectHelper.isEmptyObject(response.data)) {
                        this.bookingItems = response.data;
                        if (this.bookingItems.promocode === 'invalid') {
                            this.promoErrorMessage = 'Promo code invalid';
                        } else if (this.bookingItems.promocode) {
                            this.promocode = this.bookingItems.promocode;
                        }

                        this.initTooltips();

                        if(this.bookingItems.hasOwnProperty('ccs_support') && this.bookingItems.ccs_support) {
                            if (this.bookingItems.ccs_options) {
                                this.ccsSupportOptions = [this.bookingItems.ccs_options];
                            }
                            this.$nextTick(() => {
                                this.ccs_support = this.bookingItems.ccs_support;
                            });
                        } else {
                            this.ccs_support = null;
                        }

                        if(this.isStaffEditBO) {
                            this.notification.subject = `Notification Order #${this.bookingItems.bookingNumberId} ${this.bookingItems.productName}`;
                        }

                    } else {
                        this.bookingItems = {};
                    }
                } catch (error) {
                    this.bookingItems = {};
                    if (!error.response?.isCancel && (!error.name === 'AbortError' || !error.name === 'CanceledError') && (!error.message?.includes('aborted') || !error.message?.includes('canceled'))) {
                        errorHelper.error(error);
                    }
                    this.errorMessage = errorHelper.errorMessage(error);
                } finally {
                    if(!this.isStandalone) {
                        elementHelper.loader.hide(loaderId);
                    }
                }
            } else {
                await this.$refs.googleRecaptcha.verify().then(async token => {
                    payload.token = token;

                    try {
                        const response = await AjxService.post(endpoint, payload);
                        if (!objectHelper.isEmptyObject(response.data)) {
                            this.bookingItems = response.data;
                            if (this.bookingItems.promocode === 'invalid') {
                                this.promoErrorMessage = 'Promo code invalid';
                            } else if (this.bookingItems.promocode) {
                                this.promocode = this.bookingItems.promocode;
                            }

                            this.initTooltips();

                            if(this.bookingItems.hasOwnProperty('ccs_support') && this.bookingItems.ccs_support) {
                                if (this.bookingItems.ccs_options) {
                                    this.ccsSupportOptions = [this.bookingItems.ccs_options];
                                }
                                this.$nextTick(() => {
                                    this.ccs_support = this.bookingItems.ccs_support;
                                });
                            } else {
                                this.ccs_support = null;
                            }

                            if(this.isStaffEditBO) {
                                this.notification.subject = `Notification Order #${this.bookingItems.bookingNumberId} ${this.bookingItems.productName}`;
                            }
                        } else {
                            this.bookingItems = {};
                        }
                    } catch (error) {
                        this.bookingItems = {};
                        if (!error.response?.isCancel && (!error.name === 'AbortError' || !error.name === 'CanceledError') && (!error.message?.includes('aborted') || !error.message?.includes('canceled'))) {
                            errorHelper.error(error);
                        }
                        this.isMissingRequest = true;
                    }
                });
            }
        },
        async addShoppingCart(event) {
            const isCs = this.bookingItems.hasOwnProperty('cs') && formatHelper.parseBoolean(this.bookingItems.cs);
            if (isCs && !this.ccs_support) {
                this.ccs_support_error = true;
                sweetAlertHelper.alert(
                    'Local Agent Support',
                    "<div class='lh-1-2 fs-xs'>Please select a local agent support to continue with your booking.</div>",
                    'warning'
                );
                return;
            } else {
                this.ccs_support_error = false;
            }

            const endpoint = `/booking/shopping-cart/add/${this.confirmId}`;
            const loaderId = utilHelper.getUniqueId();
            let element = null;
            let payload = {};

            if (!this.isStandalone) {
                element = this.$el.closest('.modal-content');
            } else {
                element = this.$el.querySelector('.booking-detail');
            }

            if (element) {
                element.classList.add('position-relative');
            }

            elementHelper.loader.show(loaderId, element, 36, 36, 'dots');

            if (this.promocode && this.promocode.length >= 5) {
                payload.promocode = this.promocode;
            }

            if (this.ccs_support) {
                payload.ccs_support = this.ccs_support;
            }

            if (this.loggedIn) {
                if(!this.isStandalone) {
                    payload.staff = true;
                }

                try {
                    const response = await ApiService.post(endpoint, payload);
                    if(this.isStandalone) {
                        window.location.href = `/booking/shopping-cart`;
                    } else {
                        this.$emit('goShoppingCart', {shoppingCartId:response.data.scart});
                    }
                } catch (error) {
                    if (!error.response?.isCancel && (!error.name === 'AbortError' || !error.name === 'CanceledError') && (!error.message?.includes('aborted') || !error.message?.includes('canceled'))) {
                        if (error.response && error.response.status === 422) {
                            const message = error.response.data.error || error.response.data.message || 'Validation error';
                            sweetAlertHelper.alert('Validation Error', `<div class='lh-1-2 fs-xs'>${message}</div>`, 'error');
                        } else {
                            errorHelper.error(error);
                        }
                    }

                    if(this.isStandalone) {
                        if (!(error.response && error.response.status === 422)) {
                            this.isMissingRequest = true;
                        }
                    } else {
                        this.errorMessage = errorHelper.errorMessage(error);
                    }
                } finally {
                    elementHelper.loader.hide(loaderId);
                    if(element) {
                        element.classList.remove('position-relative');
                    }
                }
            } else {
                await this.$refs.googleRecaptcha.verify().then(async token => {
                    payload.token = token;

                    try {
                        const response = await AjxService.post(endpoint, payload);
                        window.location.href = `/booking/shopping-cart`;
                    } catch (error) {
                        if (!error.response?.isCancel && (!error.name === 'AbortError' || !error.name === 'CanceledError') && (!error.message?.includes('aborted') || !error.message?.includes('canceled'))) {
                            if (error.response && error.response.status === 422) {
                                const message = error.response.data.error || error.response.data.message || 'Validation error';
                                sweetAlertHelper.alert('Validation Error', `<div class='lh-1-2 fs-xs'>${message}</div>`, 'error');
                            } else {
                                errorHelper.error(error);
                            }
                        }
                        if (!(error.response && error.response.status === 422)) {
                            this.isMissingRequest = true;
                        }
                    } finally {
                        elementHelper.loader.hide(loaderId);
                        if(element) {
                            element.classList.remove('position-relative');
                        }
                    }
                }).catch(error => {
                    window.location.reload();
                });
            }
        },
        async applyPromoCode() {
            this.promoErrorMessage = null;
            if (!this.promocode || this.promocode.length < 5) {
                this.promoErrorMessage = 'Promo code must be at least 5 characters';
                return;
            }
            const loaderId = utilHelper.getUniqueId();
            const element = this.$el.querySelector('.booking-detail');
            if (element) {
                element.classList.add('position-relative');
            }
            elementHelper.loader.show(loaderId, element, 36, 36, 'dots');
            try {
                await this.getBookingItems();
            } finally {
                elementHelper.loader.hide(loaderId);
                if (element) {
                    element.classList.remove('position-relative');
                }
            }
        },
        async removePromoCode() {
            this.promocode = null;
            this.promoErrorMessage = null;
            this.ccs_support = null;
            this.ccsSupportOptions = [];
            if (this.$refs.ccsSelectAgent && typeof this.$refs.ccsSelectAgent.reset === 'function') {
                this.$refs.ccsSelectAgent.reset();
            }
            const loaderId = utilHelper.getUniqueId();
            const element = this.$el.querySelector('.booking-detail');
            if (element) {
                element.classList.add('position-relative');
            }
            elementHelper.loader.show(loaderId, element, 36, 36, 'dots');
            try {
                await this.getBookingItems(true);
            } finally {
                elementHelper.loader.hide(loaderId);
                if (element) {
                    element.classList.remove('position-relative');
                }
            }
        },
        async proceedToCheckout() {
            const isCs = this.bookingItems.hasOwnProperty('cs') && formatHelper.parseBoolean(this.bookingItems.cs);
            if (isCs && !this.ccs_support) {
                this.ccs_support_error = true;
                sweetAlertHelper.alert(
                    'Local Agent Support',
                    "<div class='lh-1-2 fs-xs'>Please select a local agent support to continue with your booking.</div>",
                    'warning'
                );
                return;
            } else {
                this.ccs_support_error = false;
            }

            if (this.bookingItems.available) {
                const endpoint = `/booking/review/${this.confirmId}/checkout`;
                const loaderId = utilHelper.getUniqueId();
                let element = null;
                let payload = {};

                if (!this.isStandalone) {
                    element = this.$el.closest('.modal-content');
                } else {
                    element = this.$el.querySelector('.booking-detail');
                }

                if (element) {
                    element.classList.add('position-relative');
                }

                elementHelper.loader.show(loaderId, element, 36, 36, 'dots');
                if (this.loggedIn) {
                    if(!this.isStandalone) {
                        payload.staff = true;
                    }

                    if (this.promocode && this.promocode.length >= 5) {
                        payload.promocode = this.promocode;
                    }
                    if (this.ccs_support) {
                        payload.ccs_support = this.ccs_support;
                    }
                    try {
                        const response = await ApiService.post(endpoint, payload);
                        if(response.data.hasOwnProperty('payment_id') && response.data.payment_id) {
                            if (this.isStandalone) {
                                window.location.href = `/booking/payment/${response.data.payment_id}`;
                            } else {
                                this.$emit('goInvoice', {paymentId:response.data.payment_id});
                            }
                        }
                    } catch (error) {
                        if (!error.response?.isCancel && (!error.name === 'AbortError' || !error.name === 'CanceledError') && (!error.message?.includes('aborted') || !error.message?.includes('canceled'))) {
                            if (error.response && error.response.status === 422) {
                                const message = error.response.data.error || error.response.data.message || 'Validation error';
                                sweetAlertHelper.alert('Validation Error', `<div class='lh-1-2 fs-xs'>${message}</div>`, 'error');
                            } else {
                                errorHelper.error(error);
                            }
                        }
                    } finally {
                        elementHelper.loader.hide(loaderId);
                        if (element) {
                            element.classList.remove('position-relative');
                        }
                    }
                } else {
                    await this.$refs.googleRecaptcha.verify().then(async token => {
                        payload.token = token;
                        if (this.promocode && this.promocode.length >= 5) {
                            payload.promocode = this.promocode;
                        }
                        if (this.ccs_support) {
                            payload.ccs_support = this.ccs_support;
                        }
                        try {
                            const response = await AjxService.post(endpoint, payload);
                            if(response.data.hasOwnProperty('payment_id') && response.data.payment_id) {
                                window.location.href = `/booking/payment/${response.data.payment_id}`;
                            }
                        } catch (error) {
                            if (!error.response?.isCancel && (!error.name === 'AbortError' || !error.name === 'CanceledError') && (!error.message?.includes('aborted') || !error.message?.includes('canceled'))) {
                                if (error.response && error.response.status === 422) {
                                    const message = error.response.data.error || error.response.data.message || 'Validation error';
                                    sweetAlertHelper.alert('Validation Error', `<div class='lh-1-2 fs-xs'>${message}</div>`, 'error');
                                } else {
                                    errorHelper.error(error);
                                }
                            }
                        } finally {
                            elementHelper.loader.hide(loaderId);
                            if (element) {
                                element.classList.remove('position-relative');
                            }
                        }
                    }).catch(error => {
                        window.location.reload();
                    });
                }
            }
        },
        travelAgentAddress(item) {
            let strAddress = item.address;
            if(item.city) {
                strAddress += `, ${item.city}`;
            }
            if(item.state) {
                strAddress += ` ${item.state}`;
            }
            if(item.country) {
                strAddress += ` ${item.country}`;
            }
            if(item.zipcode) {
                strAddress += ` ${item.zipcode}`;
            }
            return strAddress;
        },
        locationServiceInfo(item) {
            const _time = (item.time || '') ? `<span class="clock">${item.time}</span>` : '';
            const _mapLatLong = (item.latitude || '') && (item.longitude || '') ? `<span class="meet-point"><a href="https://www.google.com/maps/search/?api=1&query=${item.latitude},${item.longitude}" target="_blank">Meeting Point (click)</a></span>` : '';
            const _meetPoint = (item.url_map || '') ? `<span class="meet-point"><a href="${item.url_map}" target="_blank">Meeting Point (click)</a></span>` : (_mapLatLong);

            if(_time || _meetPoint) {
                return `
                        ${_time}
                        ${_meetPoint}
                    `;
            }

            return '';
        },
        runEndpointCcsSelectAgent(payload) {
            if(!payload.hasOwnProperty('filter')) {
                payload.filter = [];
            }

            if(this.bookingItems.ccs_country) {
                payload.filter.push({
                    operator:'equal',
                    property:'country_id',
                    value: this.bookingItems.ccs_country
                });
            }

            if(this.bookingItems.ccs_city) {
                payload.filter.push({
                    operator:'equal',
                    property:'city_id',
                    value: this.bookingItems.ccs_city
                });
            }

            return payload;
        },
        async sendNotification(event) {
            const form = event.target.closest('.card').querySelector('form');
            if (formHelper.validated(form)) {
                const loaderId = utilHelper.getUniqueId();
                const element = event.target.closest('.card');
                elementHelper.loader.show(loaderId, element, 32, 32, 'dots');

                try {
                    const endpoint = `/booking/review/${this.confirmId}/notification`;
                    const payload = { ...this.notification };
                    if (this.isStaffEditBO && !this.isStandalone) {
                        payload.staff = true;
                    }
                    const response = await ApiService.post(endpoint, payload);
                    sweetAlertHelper.alert('Success', 'Notification has been sent successfully.', 'success');
                    this.notification.message = null;
                    this.notification.attachments = [];
                    formHelper.reset(form);
                } catch (error) {
                    errorHelper.error(error);
                } finally {
                    elementHelper.loader.hide(loaderId);
                }
            }
        }
    }
}
</script>

<style scoped>
.tbox-string {
    input.form-control {
        box-shadow: none !important;
        outline: none !important;
    }
}
:deep(.tbox-select .form-select.lh-1 .text-muted) {
    font-size: 14px;
}
.label-travel-agent {
    font-size: .8em;
}
.lh-1-2 {
    line-height: 1.2 !important;
}
.fs-xs {
    font-size: .85em !important;
}
.is-invalid {
    border: 1px solid #ea5455 !important;
    border-radius: 0.375rem;
}
:deep(.is-invalid > .tbox-select) {
    border: 1px solid #ea5455 !important;
    border-radius: 0.375rem;
}
</style>
